// const ShanYanSDKModule = require('../util/shanyan3.0.0.3');
const ShanYanSDKModule = window.clshanyansdk || window.Gf;
import { store } from '../store/store';
import { PROXY_URL } from '../config/env';

console.log('ShanYanSDKModule', ShanYanSDKModule);

const shanyanInit = () => {
	console.log('PROXY_URL.shanyanAppId', PROXY_URL.shanyanAppId);

	let initConfig = {
		appId: PROXY_URL.shanyanAppId,
		appKey: PROXY_URL.shanyanAppKey
	};
	ShanYanSDKModule.Init(initConfig, (response) => {
		// 初始化结果回调函数
		let code = response.code;
		let message = response.message;
		console.log('shanyan初始化结果:', code, message);
	});
};

const shanyanStart = async () => {
	return new Promise((resolve, reject) => {
		ShanYanSDKModule.start((data) => {
			// 注意：这里不需要 async
			console.log('shanyan开始授权:移动联通', data);
			if (data.code == '200000') {
				let obj = {
					appId: PROXY_URL.shanyanAppId,
					accessToken: data.token,
					businessNo: store.state.virtualChannel || store.state.channel || store.state.businessNo,
					deviceInfo: '',
					androidId: '',
					oaid: '',
					clientType: 'h5'
				};
				resolve(obj); // ✅ 正确传递结果
			} else {
				reject(new Error('闪验授权失败')); // ✅ 正确传递错误
			}
		});
	});
};

const shanyanSetUiConfig = () => {
	let PolicyUserName = `《用户协议》`;
	let channel = store.state.virtualChannel || store.state.channel || store.state.businessNo;
	let pilicyUrl = `${PROXY_URL.policyUserUrl}${channel}` + `&title=用户协议`;
	let PrivacyName = '《隐私协议》';
	let privacyUrl = `${PROXY_URL.policyPrivacyUrl}${channel}&title=隐私协议`;
	const UiConfig = {
		setPageType: false, // 是否弹框 false 全屏，true 弹框
		setLoginTitle: '本机号码授权登录',
		// setLoginLogo: 'https://xubei-act.oss-cn-shenzhen.aliyuncs.com/zfb-images/login/xubei-logo-s.png',
		setPrivacyOne: [PolicyUserName, pilicyUrl],
		setPrivacyTwo: [PrivacyName, privacyUrl]
		// logoStyleHigh: '40px'
	};
	ShanYanSDKModule.setUIConfig(UiConfig, (data) => {
		console.log('shanyan设置UI成功', data);
	});
};
export default {
	shanyanInit,
	shanyanStart,
	shanyanSetUiConfig
};



// WEBPACK FOOTER //
// ./src/js/shanyan.js